module.exports = __webpack_public_path__ + "static/img/bg.0fbc9729.jpg";